import Window from '../../modules/window';
import Model from './model';

// Models
import ProfileCategory from './profile_category';

export default class Profile extends Model {
  static NAME = 'profile';
  static COLLECTION_NAME = "profiles";
  static URL = '/api/v2/profiles';

  static ADDONS = 'addons';
  static CERTIFICATIONS = 'certifications';
  static DEPARTMENTS ='departments';
  static EDUCATION = 'education';
  static EXPERIENCE = 'experience';
  static GET_STARTED = 'get_started';
  static INDUSTRIES = 'industries';
  static LANGUAGES = 'languages';
  static LOCATION = 'location';
  static MEMBERSHIP = 'membership';
  static P_ABOUT_ME = 'p_about_me';
  static P_CONFIRMED = 'p_confirmed';
  static P_DEPARTMENTS ='p_departments';
  static P_EDUCATION = 'p_education';
  static P_EXPERIENCE = 'p_experience';
  static P_INDUSTRIES = 'p_industries';
  static P_LANGUAGES = 'p_languages';
  static P_LOCATION = 'p_location';
  static P_PHONE = 'p_phone';
  static P_PLATFORMS = 'p_platforms';
  static P_SOCIAL = 'p_social';
  static P_TECHNOLOGIES = 'p_technologies';
  static P_WEBSITE = 'p_website';
  static PHONE = 'phone';
  static PLATFORMS = 'platforms';
  static PROFILE_READY = 'profile_ready';
  static RATE = 'rate';
  static RESUME = 'resume';
  static ROLE_TITLE = 'role_title';
  static TECHNOLOGIES = 'technologies';
  static WORK_TYPE = 'work_type';

  static CONTRACT_TYPES = {
    full_time: 'Full Time',
    part_time: 'Part Time',
  }

  static WORK_TYPES = {
    'on-site': 'Onsite',
    'hybrid': 'Hybrid',
    'remote': 'Remote only',
  }

  profileCategory() {
    if (!this.profile_category_id) return undefined;
    return ProfileCategory
      .find(this.profile_category_id)
      .then((profileCategory) => profileCategory)
      .catch((error) => Window.flash.error(error));
  }

  get workType() {
    return Profile.WORK_TYPES[this.work_type];
  }
}
